import React from 'react'

import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import { Link, StyleSheet, View } from "@react-pdf/renderer"
import DataUnavailableText from "../../DataUnavailableText"
import ListItem from "../../../ListItem"
import ErrorDataText from "../../ErrorDataText"
import ContentBox from "../../../ContentBox"
import { DataField } from "../../../Label"

const styles = StyleSheet.create({
  content: {
    marginTop: 8,
    backgroundColor: '#fff',
  },
})

const NegativeMediaZoneVariableReport = (props) => {
  const { negativeMediaData } = props

  try {
    return negativeMediaData?.links && negativeMediaData?.links?.length > 0 ? (
      <ContentBox style={styles.content}>
        <DataField label="Links relacionados:" />
        <View style={styles.content}>
          {
            addKeyToObjectsArray(negativeMediaData?.links?.map(link => {
              return { link: link }
            }))?.map((media_link) => {
              return (
                <ListItem key={media_link?.key}>
                  <Link src={media_link?.link} target="_blank" rel="noopener noreferrer">{media_link?.link}</Link>
                </ListItem>
              )
            })
          }
        </View>
      </ContentBox>
    ) : (
      <DataUnavailableText />
    )
  } catch (err) {
    return (
      <ErrorDataText
        exception={err}
        contextName="NegativeMediaZoneVariableReport"
        extraData={negativeMediaData}
      />
    )
  }
}

export default NegativeMediaZoneVariableReport
